import CanvasBase from "./CanvasBase";
import goalScoreAreaImage from "../../../assets/img/demo/goal-score-area-image.png";
import {complex} from "mathjs";

class GoalScoreArea extends CanvasBase {
    constructor(props) {
        super(props);
        this.handleCanvasBackgroundLoaded = this.handleCanvasBackgroundLoaded.bind(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.clear();
        this.initBackground();
    }


    canvasBackground() {
        return this.goalScoreAreaImage();
    }

    handleCanvasBackgroundLoaded() {
        this.drawBall();
    }

    drawBall() {
        const {circle} = this.canvasConfig();
        const {ball} = this.props;
        const {x, z} = ball;

        const o = complex(x, z);
        const {radius, color} = circle;
        this.drawCircle(o, radius, color, null, true);
    }

    goalScoreAreaImage = () => goalScoreAreaImage;

    canvasConfig = () => ({
        width: 64,
        resolution: {width: 320, height: 150},
        line: {
            width: 14,
            dash: 8,
            space: 16,
            style: '#FFFFFF',
            arrowHead: {
                length: 6,
            },
        },
        circle: {
            radius: 20,
            color: '#F2C94C',
        }
    });


    /**
     * @override
     * @param x {float} The x-coordinate.
     * @returns {float} The x-coordinate after apply offset.
     */
    offsetX = (x) => {
        const {resolution} = this.canvasConfig();
        const {width} = resolution;

        return x + width / 2
    };

    /**
     * @override
     * @param y {float} The y-coordinate.
     * @returns {float} The y-coordinate after apply offset.
     */
    offsetY = (y) => this.offsetZ(y);

    /**
     *
     * @param z {float} The z-coordinate.
     * @returns {float} The z-coordinate after apply offset.
     */
    offsetZ = (z) => {
        const {resolution} = this.canvasConfig();
        const {height} = resolution;

        return -z + height
    }
}

export default GoalScoreArea;
